import { Box, Chip, Typography } from '@mui/material';
import { versionStatus, windowText } from './effectiveWindow';
import SetBy from './SetBy';

// "When does this row apply" for a threshold table: the window as text plus a Current / Scheduled chip, and under it who
// set this version up and when (every config table shows this cell, so every one of them says who made each row).
const STATUS_COLOR = { Current: 'success', Scheduled: 'info', Ended: 'default' };

const AppliesCell = ({ row, month }) => {
  const status = versionStatus(row, month); // relative to the month being worked on
  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
        <Typography variant="body2">{windowText(row)}</Typography>
        <Chip size="small" variant="outlined" color={STATUS_COLOR[status]} label={status} />
      </Box>
      <SetBy name={row.created_by_name} at={row.created_at} />
    </Box>
  );
};

export default AppliesCell;
